import { useMemo } from 'react';
import { ProductCatalogSearchQueryOrderBy } from '@graphql/generated';
import { OptionType } from './SortByPrice.types';
import { useTranslation } from '@shared/core';

export const useSortByPrice = () => {
  const { t } = useTranslation('catalogRegistry');
  const { sortByPriceOptions } = t('refinementsPanel');
  const options: OptionType[] = useMemo(
    () => [
      { value: ProductCatalogSearchQueryOrderBy.featured, label: sortByPriceOptions[ProductCatalogSearchQueryOrderBy.featured]() },
      { value: ProductCatalogSearchQueryOrderBy.priceAsc, label: sortByPriceOptions[ProductCatalogSearchQueryOrderBy.priceAsc]() },
      { value: ProductCatalogSearchQueryOrderBy.priceDesc, label: sortByPriceOptions[ProductCatalogSearchQueryOrderBy.priceDesc]() }
    ],
    [sortByPriceOptions]
  );

  return {
    options
  };
};
